import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, tokenStore, formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      tokenStore.set(data.access_token);
      toast.success("Bienvenido", { description: data.user.email });
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("No se pudo iniciar sesión", {
        description: formatApiError(err.response?.data?.detail) || err.message,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-vp-navy bg-pallet-grid flex items-center justify-center p-6"
    >
      <div className="w-full max-w-md bg-vp-navy-deep border-2 border-vp-yellow shadow-brutal">
        <div className="border-b-2 border-vp-yellow px-8 py-6 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/logo-vigopal.png"
              alt="Vigopal"
              className="w-12 h-12 object-contain border-2 border-vp-yellow"
            />
            <div>
              <div className="label-industrial">Vigopal · Acceso interno</div>
              <h1 className="heading-industrial text-2xl mt-1 text-white">Panel admin</h1>
            </div>
          </div>
          <div className="w-12 h-12 bg-vp-red text-white flex items-center justify-center">
            <Lock size={20} />
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-8 space-y-5">
          <div>
            <label className="label-industrial mb-2 block">Correo</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              data-testid="admin-email"
              className="w-full bg-vp-navy border-2 border-white/20 px-3 py-3 text-white placeholder-white/40 focus:border-vp-yellow"
              placeholder="admin@vigopal.cl"
            />
          </div>
          <div>
            <label className="label-industrial mb-2 block">Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              data-testid="admin-password"
              className="w-full bg-vp-navy border-2 border-white/20 px-3 py-3 text-white placeholder-white/40 focus:border-vp-yellow"
              placeholder="••••••••"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-vp-red hover:bg-vp-yellow hover:text-[#001E62] disabled:opacity-60 text-white font-bold uppercase tracking-widest text-sm px-6 py-4 inline-flex items-center justify-center gap-3 transition-colors"
          >
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Ingresar"}
          </button>

          <a
            href="/"
            data-testid="admin-back-home"
            className="block text-center text-xs label-industrial hover:text-white mt-4"
          >
            ← Volver al sitio
          </a>
        </form>
      </div>
    </div>
  );
}
